import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {},
    template: `
        <div class="heading01 type01">
            <h1>{{ 'skill.Add skill' | translate }}</h1>
        </div>
        <user-skill-form-skill mode="add"></user-skill-form-skill>
    `
})
export default class {}



// WEBPACK FOOTER //
// ./src/app/components/user/skill/add/skill/index.js